<template>
  <div
    class="pr-1 ml-1 inline-flex items-center"
    :class="[
      phaseData.id === VICE_SESSION_PHASES.CONSULTATION
        ? 'step-phase-consultation'
        : phaseData.id === VICE_SESSION_PHASES.INTRODUCTION
        ? 'step-phase-introduction'
        : 'step-phase-debrief',
      {
        'rounded-full cursor-pointer border-transparent hover:text-white hover:bg-gray-500':
          isClickable,
      },
    ]"
    @click="handleClick"
    v-tippy="{
      content: isClickable ? `Go to ${phaseData.title.toLowerCase()}` : '',
      theme: 'light-border',
      interactive: true,
    }"
  >
    <span
      class="block h-px w-7 ml-1 bg-white"
      v-if="phaseData.id !== VICE_SESSION_PHASES.INTRODUCTION"
    ></span>
    <span
      class="
        inline-flex
        justify-center
        items-center
        prose-sm
        font-bold
        w-10.5
        h-10.5
        mr-2
        border-2 border-white
        rounded-full
      "
    >
      {{ phaseData.id }}
    </span>
    <span class="text-sm font-medium leading-5">{{ phaseData.title }}</span>
  </div>
</template>

<script>
import { computed } from 'vue';
import { directive } from 'vue-tippy';
import { VICE_SESSION_PHASES } from '@/Utils/vice-constants';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

export default {
  directives: {
    tippy: directive,
  },
  props: {
    isClinician: {
      type: Boolean,
      required: true,
    },
    phaseData: {
      type: Object,
      required: true,
    },
    currentPhase: {
      type: Number,
      required: true,
    },
    livePhase: {
      type: Object,
    },
    hasLivePhase: {
      type: Boolean,
      required: true,
    },
    endCurrentPhase: {
      type: Function,
    },
  },
  setup(props) {
    const isClickable = computed(
      () =>
        props.hasLivePhase &&
        props.isClinician &&
        (props.currentPhase === VICE_SESSION_PHASES.CONSULTATION ||
          (props.currentPhase === VICE_SESSION_PHASES.INTRODUCTION &&
            props.phaseData.id === VICE_SESSION_PHASES.CONSULTATION) ||
          (props.currentPhase === VICE_SESSION_PHASES.DEBRIEF &&
            props.phaseData.id === VICE_SESSION_PHASES.CONSULTATION)),
    );

    const handleClick = () => {
      if (isClickable.value) {
        props.endCurrentPhase(props.livePhase);
      }
    };

    return {
      isClickable,
      handleClick,
      VICE_SESSION_PHASES,
    };
  },
};
</script>

<style lang="scss" scoped></style>
